export const primates_links = [
    { "title" :"Feeding",
    "spanishTitle" :"ALIMENTOS",
    "links" : [
        {"ipath":"/images/mazure.jpg",
        "web_url":"http://www.mazuri.com"
        },
        {"ipath":"/images/versele.jpg",
            "web_url":"https://www.versele-laga.com"
        },
        {"ipath":"/images/fauna.jpg",
                "web_url":"https://www.faunafoods.com/"
        }
     
      
    ] 
},
{ "title" :"Zoo designers",
        "spanishTitle" :"Fence and other materials",
        "links" : [
            {"ipath":"/images/heras.jpg",
            "web_url":"https://www.heras-mobile.com"
            }
          
        ] 
 },
 { "title" :"Husbandry",
    "spanishTitle" :"Maintanance Links",
    "links" : [
        {"ipath":"/images/mazure.jpg",
            "web_url":"http://www.mazuri.com"
            }
      
    ] 
},
{ "title" :"Educational material",
    "spanishTitle" :"Educational labels",
    "links" : [
        {"ipath":"/images/mazure.jpg",
            "web_url":"http://www.mazuri.com"
            }
      
    ] 
},
{ "title" :"Transport",
    "spanishTitle" :"Transport and crates",
    "links" : [
        {"ipath":"/images/mazure.jpg",
            "web_url":"http://www.mazuri.com"
            }
      
    ] 
},
{ "title": "books",
    "spanishTitle" :"Books and literature",
    "links" : [
        {"ipath":"/images/mazure.jpg",
            "web_url":"http://www.mazuri.com"
            }
      
    ] 
}
]


